import {
  AbstractControl,
  FormBuilder,
  FormGroup,
  ValidationErrors,
  ValidatorFn,
  Validators,
} from '@angular/forms';
import { FormField } from '../../../dto/util/form-field';
import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  Output,
  ViewChild,
} from '@angular/core';
import { EjemploDto } from '../../../dto/justino/ejemplo.dto';

@Component({
  selector: 'app-modal-ejemplo',
  templateUrl: './modal-ejemplo.component.html',
  styleUrl: './modal-ejemplo.component.scss',
})
export class ModalEjemploComponent {
  @ViewChild('modalEjemplo')
  modalEjemplo!: ElementRef;
  ejemploForm!: FormGroup;
  ejemploFieldsForm: FormField[] = [
    {
      name: 'descripcion',
      label: 'Descripción',
      type: 'textarea',
      required: true,
      width: '12',
      visible: true,
      errorMessages: {
        required: 'La descripción es requerida',
      },
    },
  ];

  actores: string[] = ['Usuario', 'Sistema'];
  actorFlag: boolean = true;

  @Input() actor: string = 'Ninguno';
  @Input() editFlag: boolean = false;
  @Input() ejemplo: EjemploDto | undefined = undefined;
  @Output() ejemploEmitter = new EventEmitter<any>();
  @Output() updatedEjemplo = new EventEmitter<any>();

  constructor(private fb: FormBuilder) {}

  ngOnInit(): void {
    const formControls: any = {};
    this.ejemploFieldsForm.forEach(field => {
      formControls[field.name] = [null, []];
    });
    this.ejemploForm = this.fb.group(formControls);
  }

  createForm(): void {
    if (this.actor === 'Usuario') {
      this.actor = 'Sistema';
      this.actorFlag = false;
    }
    const formControls: any = {};
    this.ejemploFieldsForm.forEach(field => {
      const validators = [];
      if (field.required) {
        validators.push(Validators.required);
      }
      formControls[field.name] = [null, validators];
    });
    this.ejemploForm = this.fb.group(formControls);
    this.fillFormWithData();
  }

  fillFormWithData(): void {
    if (this.ejemplo) {
      this.actor = this.ejemplo.actor;
      this.ejemploForm.patchValue({
        descripcion: this.ejemplo.texto,
      });
    }
  }

  submitForm(): void {
    if (this.ejemploForm.valid) {
      // Verificar si es edición o creación
      if (this.editFlag && this.ejemplo) {
        this.ejemplo.texto = this.ejemploForm.get('descripcion')?.value;
        this.ejemplo.actor = this.actor;
        this.updatedEjemplo.emit(this.ejemplo);
        this.editFlag = false;
        this.ejemplo = undefined;
      } else {
        // Crear nuevo objeto
        const dto = {
          texto: this.ejemploForm.get('descripcion')?.value,
          actor: this.actor === 'Ninguno' ? 'Usuario' : this.actor,
        };
        this.ejemploEmitter.emit(dto);
      }
      this.abrirCerrarModal();
      this.ejemploForm.reset();
    } else {
      this.ejemploForm.markAllAsTouched();
    }
  }

  getErrorMessage(field: string): string | null {
    const control = this.ejemploForm.get(field);
    if (control?.invalid && control.touched) {
      const errorType = Object.keys(control.errors!)[0];
      return (
        this.ejemploFieldsForm.find(f => f.name === field)?.errorMessages?.[
          errorType
        ] || 'Campo inválido'
      );
    }
    return null;
  }

  abrirCerrarModal() {
    this.actorFlag = true;
    this.createForm();
    this.modalEjemplo.nativeElement.click();
  }

  onChangeActor(event: any) {
    this.actor = event.target.value;
  }
}
